import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type ProjectAdobeFragment = { __typename?: 'Project', adobeAssetId?: string | null };

export const ProjectAdobe = /*#__PURE__*/ gql`
    fragment ProjectAdobe on Project {
  adobeAssetId
}
    ` as unknown as DocumentNode<ProjectAdobeFragment, unknown>;

        

        
export const useProjectAdobeFragment = (
  input: string | Omit<UseFragmentOptions<ProjectAdobeFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<ProjectAdobeFragment>({
    fragment: ProjectAdobe,
    fragmentName: 'ProjectAdobe',
    ...options,
  });
};
  
        